import React from 'react';

import { FoldableWrapper } from './foldable-wrapper';
import { OneColumnLayout } from './layout-renderers/one-column-layout';
import { TwoColumnsLayout } from './layout-renderers/two-columns-layout';
import { TwoRowsLayout } from './layout-renderers/two-rows-layout';
import type { LayoutRenderer, LayoutType } from './types';

/**
 * Higher-order component that wraps any layout component with FoldableWrapper
 * This eliminates code duplication for all foldable layout variants
 */
const makeFoldable = (BaseLayout: LayoutRenderer): LayoutRenderer => {
	return (props) => {
		return (
			<FoldableWrapper
				defaultFoldedState={props.defaultFoldedState}
				header={props.header}
				content={props.content}
				isStreaming={props.isStreaming}
				renderElement={props.renderElement}
				sectionKey={props.sectionKey}
			>
				<BaseLayout {...props} />
			</FoldableWrapper>
		);
	};
};

// Create foldable versions by wrapping base components
const OneColumnFoldableLayout = makeFoldable(OneColumnLayout);
const TwoColumnsFoldableLayout = makeFoldable(TwoColumnsLayout);
const TwoRowsFoldableLayout = makeFoldable(TwoRowsLayout);

/**
 * Centralized map of layout renderers
 * Maps layout types to their corresponding component references
 */
export const layoutRenderers: Record<LayoutType, LayoutRenderer> = {
	'one-column': OneColumnLayout,
	'one-column-foldable': OneColumnFoldableLayout,
	overview: OneColumnLayout, // Overview uses the same logic as one-column
	'two-columns': TwoColumnsLayout,
	'two-columns-foldable': TwoColumnsFoldableLayout,
	'two-rows': TwoRowsLayout,
	'two-rows-foldable': TwoRowsFoldableLayout,
};
